<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useInvoiceModalStore } from '@stores/useInvoiceModalStore';
import SlideIn from '@components/Slidein.vue';
import StripeOnboarding from '@pages/pay/onboarding/StripeOnboarding.vue';
import StripeCreateDiscount from '@pages/pay/invoices/StripeCreateDiscount.vue';
import CreditNoteForm from '@pages/pay/invoices/CreditNoteForm.vue';
import StripeCreateInvoice from '@pages/pay/invoices/StripeCreateInvoice.vue';
import StripeInfosSlider from '@pages/pay/invoices/StripeInfosSlider.vue';
import AdafEditAmount from '@organisms/adaf/AdafEditAmount.vue';
import AdafEditSubscription from '@organisms/adaf/AdafEditSubscription.vue';
import EditSubscription from '@pages/pay/invoices/EditSubscription.vue';
import UpdateInvoiceStatus from '@pages/pay/invoices/UpdateInvoiceStatus.vue';
import { EVENT_SLIDERS } from './event-constants';

const modalStore = useInvoiceModalStore();
const { isOpen, title, componentName } = storeToRefs(modalStore);
const { closeModal, reset } = modalStore;

const components = {
  [EVENT_SLIDERS.CREATE_STRIPE_ACCOUNT]: StripeOnboarding,
  [EVENT_SLIDERS.CREATE_STRIPE_CREDIT_NOTE]: StripeCreateDiscount,
  [EVENT_SLIDERS.CREATE_CREDIT_NOTE]: CreditNoteForm,
  [EVENT_SLIDERS.CREATE_PARTIAL_CREDIT_NOTE]: CreditNoteForm,
  [EVENT_SLIDERS.CREATE_STRIPE_INVOICE]: StripeCreateInvoice,
  [EVENT_SLIDERS.INFOS_STRIPE_INVOICES]: StripeInfosSlider,
  [EVENT_SLIDERS.EDIT_AMOUNT_ADAF]: AdafEditAmount,
  [EVENT_SLIDERS.EDIT_SUBSCRIPTION_ADAF]: AdafEditSubscription,
  [EVENT_SLIDERS.MODIFY_SUBSCRIPTION]: EditSubscription,
  [EVENT_SLIDERS.UPDATE_INVOICE_STATUS]: UpdateInvoiceStatus,
};

const currentComponent = computed(() => components[componentName.value]);
const close = () => {
  currentComponent.value = null;
  reset();
  closeModal();
};
</script>

<template>
  <div class="actions-slidein">
    <SlideIn :is-opened="isOpen" @close="close">
      <template #header>
        {{ title }}
      </template>
      <template #body>
        <component :is="currentComponent" @close="close" />
      </template>
    </SlideIn>
  </div>
</template>
